//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'SingleCoin',
  props: {
    coin: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  computed: {
    isUsdtIrt () {
      return String(this.coin && this.coin.symbol).toUpperCase() === 'USDT_IRT'
    },
    ...mapGetters({
      getSymbolFaName: 'coins/getSymbolFaName',
      buyDollarPrice: 'coins/buyDollarPrice'
    })
  }
}
